export default [
  {
    path: '/',
    component: resolve => require(['./pages/Content'], resolve),
    children: [
      {
        path: '/',
        component: resolve => require(['./pages/Index'], resolve),
        meta: {
          isHome: true
        }
      },
      {
        path: '/list/:page?',
        component: resolve => require(['./pages/List'], resolve)
      },
      {
        path: '/detail/:guid',
        component: resolve => require(['./pages/Detail'], resolve)
      },
      {
        path: '/edit/:guid?',
        component: resolve => require(['./pages/Edit'], resolve)
      },
      {
        path: '/wordfrequency/:type/:keyword',
        component: resolve => require(['./pages/WordFrequency'], resolve)
      },
      {
        path: '/login',
        component: resolve => require(['./pages/LoginTransit'], resolve)
      },
      {
        path: '/frequencyapi/:type/:keyword',
        component: resolve => require(['./pages/WordFrequencyapi'], resolve)
      },
    ]
  },
  {
    path: "*",
    redirect: "/"
  }
]
